import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { getConsent, setConsent, loadTrackersIfConsented, syncClarityForRoute } from "@/lib/consent";
import { Link, useLocation } from "react-router-dom";

const CookieConsentBanner = () => {
  const [visible, setVisible] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // Load trackers if a previous visit already accepted
    loadTrackersIfConsented();
    if (getConsent() === null) {
      const t = setTimeout(() => setVisible(true), 5000);
      return () => clearTimeout(t);
    }
  }, []);

  // On every route change, gate Clarity on/off based on path allowlist.
  useEffect(() => {
    syncClarityForRoute(location.pathname);
  }, [location.pathname]);

  if (!visible) return null;

  const handleAccept = () => {
    setConsent("accepted");
    setVisible(false);
  };
  const handleReject = () => {
    setConsent("rejected");
    setVisible(false);
  };

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Cookie consent"
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:max-w-md z-[100] rounded-2xl bg-tk-surface border border-tk-text/10 shadow-2xl p-5 font-display text-tk-text"
    >
      <h2 className="text-base font-medium mb-2">We use cookies</h2>
      <p className="text-sm text-tk-text/70 leading-relaxed">
        We use essential cookies to run the site (including a first-party
        identifier so we can keep your session and protect your account).
        Optional analytics cookies (Google Analytics, Microsoft Clarity and
        attribution tracking) help us understand how visitors use Tony Knows.
        See our{" "}
        <Link to="/cookie-policy" className="underline hover:text-tk-primary">
          Cookie Policy
        </Link>
        .
      </p>
      <div className="mt-4 flex flex-col-reverse sm:flex-row gap-2 sm:justify-end">
        <Button
          variant="outline"
          onClick={handleReject}
          className="rounded-full border-tk-text/15 text-tk-text hover:bg-tk-text/5 hover:text-tk-text"
        >
          Reject optional
        </Button>
        <Button
          onClick={handleAccept}
          className="rounded-full bg-tk-primary text-white hover:bg-tk-primary/90"
        >
          Accept all
        </Button>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
